import { CREHANA_BASE_URL_PRD } from '@crehana/constants';

export default {
  og_data: {
    type: 'website',
    site_name: CREHANA_BASE_URL_PRD,
    title: 'Crehana',
    description:
      'Descubre cupones de descuento en Crehana para aprender online. Canjea códigos para acceder a tus promociones y desarrolla tu potencial.',
  },
};
